import React from "react";
import { useTranslation } from "react-i18next";
import style from "./SearchGroup.module.css";

import SearchItem from "../searchItem/SearchItem";

import { Command } from "cmdk";

function SearchGroup({ content, type, nameKey }) {
	const { t } = useTranslation();

	return (
		<Command.Group>
			<div className={style.group}>
				<div className={style.type}>
					<span>{t(nameKey)}</span>
					<div className={style.line}></div>
				</div>
				<div className={style.itemsHolder}>
					{content.map((item) => (
						<SearchItem key={item.id} type={type} item={item} />
					))}
				</div>
			</div>
		</Command.Group>
	);
}

export default SearchGroup;
